import memoize from 'lodash/memoize';
import { AmplifyGet } from '@sunrun/sales-experience-shared/amplify-api-wrapper';
import useSWR from 'swr';
import { useHybridToken } from './Auth';
import { useUserProfile } from './UserProfile';
import { logger } from './logger';

type RetailStoreObj = {
  accountId: string;
  accountNumber: string;
  channelTypes: string;
  classification: string;
  name: string;
  partnerLocation: string;
  recordType: string;
  site: string;
  subVerticalType: string;
  verticalType: string;
  lastModifiedBy: string;
  lastModifiedByName: string;
  lastModifiedById: string;
  lastModifiedDate: string;
  createdById: string;
  createdByName: string;
  createdBy: string;
  createdDate: string;
};

const getRetailStoreAddresses = memoize(
  async (contactId: string, authKey: string): Promise<any> => {
    try {
      const response = await AmplifyGet<{ stores: any }>(
        'Get Retail Store Addresses',
        'SalesExpDashboardApi',
        '/getRetailStoreAddresses',
        {
          headers: {
            Authorization: `Bearer ${authKey}`,
          },
        },
        logger,
        {
          expectedErrorCodes: [401, 403],
        },
      );
      const stores = response.stores;
      return stores;
    } catch (error: any) {
      throw error;
    }
  },
);

const useRetailStores = () => {
  const { hybridToken } = useHybridToken();
  const { userProfile } = useUserProfile();

  return useSWR(
    ['/getRetailStoreAddresses', userProfile?.contactId, hybridToken],
    ([, contactId, token]) => {
      if (!contactId) {
        return null;
      }
      if (!token) {
        return null;
      }

      return getRetailStoreAddresses(contactId, token) as Promise<
        RetailStoreObj[]
      >;
    },
    {
      revalidateOnFocus: false,
      errorRetryCount: 3,
    },
  );
};

export type { RetailStoreObj };
export { getRetailStoreAddresses, useRetailStores };
